/*=============================
=             Menu            =
=============================*/

var menu = document.getElementById('menu'),
    mobileMenuButton = document.getElementById('mobile-menu-button'),
    popupMenu = document.getElementById('popup-menu');

body.addEventListener('click', function(e) {
    checkAndCloseMenu(e.target);
});

mobileMenuButton.addEventListener('click', function (e) {
    e.preventDefault();
    Velocity(popupMenu, 'fadeIn', {duration: 500, display: 'flex'});
    toggleMenuBodyClass(true)
})

document.querySelector('#popup-menu .close_button.open').addEventListener('click', function(e){
    e.preventDefault();
    Velocity(popupMenu, 'fadeOut', {duration: 500, display: 'none'});
    toggleMenuBodyClass(false)
})

document.addEventListener('keydown', function(e) {
    if(e.key == 'Escape')
        checkAndCloseMenu(menu);
});

function checkAndCloseMenu(e) {
    var open = openMenu(e);

    if(open) {
       closeMenu(open);
    }
}

[].slice.call(document.querySelectorAll('#cta-links button:not(.lang-button), #popup-menu button:not(.lang-button):not(#search-button)')).forEach(function(navLink) {
    navLink.addEventListener('click', toggleMenu);
});

function toggleMenu() {
    closeMenu(openMenu(this));

    var parent = this.parentNode.parentNode,
        openSibling = parent.querySelector('.open'),
        isOpen = this.classList.contains('open');

    if(parent.classList.contains('submenu') && openSibling && openSibling != this)
        closeMenu(openSibling);

    Velocity(this.nextElementSibling, (isOpen ? 'slideUp' : 'slideDown'), {duration: 150, display: !isOpen ? 'flex' : 'none'});

    this.classList.toggle('open');
    this.parentNode.classList.toggle('submenu-open');

    this.setAttribute('aria-expanded', (this.getAttribute('aria-expanded') == 'true' ? 'false' : 'true'));

}

function closeMenu(el) {
    if(el) {
        var submenu = el.nextElementSibling;

        Velocity(submenu, 'slideUp', {duration: 150});

        el.classList.remove('open');
        el.parentNode.classList.remove('submenu-open');

        closeMenu(submenu.querySelector('.open'));
    }
}

function openMenu(el) {
    var openButton = popupMenu.querySelector('button.open:not(#mobile-menu-button)');

    return openButton && !openButton.parentNode.contains(el) ? openButton : false;
}

function toggleMenuBodyClass(open) {
    if(open)
        body.classList.add('menu-open');
    else
        body.classList.remove('menu-open');

    setFocus((open ? true : false), popupMenu);
}

function setFocus(open, container) {
    [].slice.call(document.querySelectorAll('#header, #hero, #main, #footer')).forEach(function(parent) {
        if(parent != container) {
            parent.setAttribute('aria-hidden', open);

            [].slice.call(parent.querySelectorAll('a, button, input')).forEach(function(link) {
                if(open)
                    link.setAttribute('tabindex', '-1');
                else
                    link.removeAttribute('tabindex');
            });
        }
    });
}
